import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// WORK IN PROGRESS APIs
// Legacy route: /Accounts/WorkInProgress
// ==============================================

// 1. Get Cost Centers available to this user/role for Work Progress (GET)
export const getCCForWorkInProgress = async ({ userId, roleId }) => {
    try {
        const queryParams = new URLSearchParams({ UserId: userId, Roleid: roleId });
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetCCForWorkInProgress?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get CC For Work In Progress API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Clients for a Cost Center (GET)
export const getClientsByCCForWorkProgress = async (ccCode) => {
    try {
        const queryParams = new URLSearchParams({ CCCode: ccCode });
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetClientsbyCCForWorkProgress?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get Clients By CC For Work Progress API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get Sub-Clients for a Cost Center + Client (GET)
export const getSubClientsByClientForWP = async ({ ccCode, clientcode }) => {
    try {
        const queryParams = new URLSearchParams({ CCCode: ccCode, clientcode });
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetSubClientsbyClientForWP?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get Sub-Clients By Client For WP API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Get Client PO Numbers for Work Progress (GET)
export const getClientPOforWP = async ({ ccCode, client, subClient, id = 0 }) => {
    try {
        const queryParams = new URLSearchParams({ CCCode: ccCode, Client: client, SubClient: subClient, Id: id });
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetClientPOforWP?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get Client PO for WP API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 5. Save the Work Progress entry (POST)
export const saveWorkProgress = async (params) => {
    try {
        const payload = {
            CCCode: params.ccCode,
            Clientcode: params.clientcode,
            SubClientcode: params.subClientcode,
            PONumber: params.poNumber,
            Date: params.date,
            Amount: params.amount,
            Description: params.description,
            Remarks: params.remarks,
            CreatedBy: params.createdBy,
            Roleid: params.roleId,
        };

        const response = await axios.post(
            `${API_BASE_URL}/Accounts/SaveWorkProgress`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Save Work Progress API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
